import fb from 'firebase/compat/app';
import 'firebase/compat/firestore';
// import 'firebase/compat/analytics';
import { firebaseConfig } from './firebase-config.js';

// Initialize Firebase
export const firebase = !fb.apps.length ? fb.initializeApp(firebaseConfig) : fb.app();

